
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzButton from "@/models/MiezzButton";
import MiezzForm from "@/models/MiezzForm";
import ProjectSiteAppService from "@/apis.machine/ProjectSiteAppService";
import DtoFormProjectSite, {
  DtoFormProjectSiteMiezzFormItems,
  DtoFormProjectSiteRules,
} from "@/models.machine/DtoFormProjectSite";
import ProjectAppService from "@/apis.machine/ProjectAppService";
import MiezzModal from "@/models/MiezzModal";

export default class ProjectSiteForm extends Vue {
  @Model() modelValue!: MiezzModal;
  @Prop() id?: string;

  form = new MiezzForm<DtoFormProjectSite, string>();

  created(): void {
    //表单-数据-初始化
    this.form.Data = new DtoFormProjectSite();
    //表单-校验
    this.form.Rules = DtoFormProjectSiteRules;
    //表单-元素配置
    this.form.Items = DtoFormProjectSiteMiezzFormItems;

    //修改元素配置
    for (const item of this.form.Items) {
      switch (item.Prop) {
        case "ProjectId":
          ProjectAppService.GetSelect().then((r) => {
            item.Options = r.data.Data;
          });
          break;
        default:
          break;
      }
    }

    this.modelValue.HandleClick = this.handleClick;
    this.modelValue.Buttons = [
      {
        Code: "submit",
        Label: "保存",
        Type: "primary",
        Size: "small",
      },
    ];

    this.handleGet();
  }

  /**查询表单数据 */
  handleGet(): void {
    if (this.id) {
      ProjectSiteAppService.GetById(this.id).then((r) => {
        if (r.data.Data) this.form.Data = r.data.Data;
      });
    } else {
      this.form.Data = new DtoFormProjectSite();
    }
  }

  /**按钮点击 */
  handleClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      case "submit":
        MiezzForm.submit(this.$refs, "ruleForm", (v) => {
          if (v) {
            ProjectSiteAppService.Post(this.form.Data)
              .then(() => {
                this.handleSubmit();
                complete();
              })
              .catch(complete);
          } else complete();
        });
        break;
      default:
        break;
    }
  }

  /**表单提交-回调 */
  @Emit()
  handleSubmit(): void {
    //
  }
}
